<script setup lang="ts">
import { computed } from 'vue'

const backgroundFallback = '/assets/background/focus.svg'
const backgroundUrl = useState<string | null>('site-background', () => null)
const effectiveBackground = ref(backgroundUrl.value || backgroundFallback)
watch(backgroundUrl, (v) => { effectiveBackground.value = v || backgroundFallback })

const cssHref = useState<string | null>("site-css", () => null);
useHead(() => ({
  link: cssHref.value
    ? [{ rel: "stylesheet", href: cssHref.value, tagPriority: 999 }]
    : [],
}));

onMounted(() => {
  // If the background image fails to load, fall back to the local SVG
  const img = new Image()
  img.src = effectiveBackground.value
  img.onerror = () => { effectiveBackground.value = backgroundFallback }
});

const style = computed(() => ({
  background: `url("${effectiveBackground.value}") no-repeat center center fixed`,
  backgroundSize: 'cover'
}));
</script>

<template>
  <div class="relative flex h-full min-h-0 p-6" :style="style">
    <nuxt-loading-indicator />
    <div class="relative w-fit m-auto">
      <slot />
    </div>
  </div>
</template>
